import React from "react";
import { Drawer } from "antd";
import { connect, useDispatch } from "react-redux";
import { NAV_TYPE_SIDE } from "constants/ThemeConstant";
import MenuContent from "./MenuContent";
import Flex from "components/shared-components/Flex";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { onMobileNavToggle } from "../../redux/actions/Theme";

export const MobileNav = ({ sideNavTheme, mobileNav, hideGroupTitle, localization = true }) => {
  const dispatch = useDispatch();
  const props = { sideNavTheme, hideGroupTitle, localization };

  const onClose = () => {
    dispatch(onMobileNavToggle(false));
  };

  return (
    <Drawer placement="left" closable={false} onClose={onClose} visible={mobileNav} bodyStyle={{ padding: 5 }}>
      <Flex flexDirection="column" className="h-100">
        <Flex justifyContent="between" alignItems="center">
          <div className="nav-close" onClick={() => onClose()}>
            <ArrowLeftOutlined />
          </div>
        </Flex>
        <div className="mobile-nav-menu">
          <MenuContent type={NAV_TYPE_SIDE} {...props} />
        </div>
      </Flex>
    </Drawer>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme, mobileNav } = theme;
  return { navCollapsed, sideNavTheme, mobileNav };
};

export default connect(mapStateToProps, null)(MobileNav);
